// import {setPassport} from "../lib/lib";
import {writable} from 'svelte/store';

let passportsObject = {
    prefix: '', // prefix before passport numbers
    token: null, //'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwZXJtaXNzaW9ucyI6WyJwa3MiXSwiaWF0IjoxNzEyOTQ3NzY5LCJleHAiOjE3MTM1NDc3Njl9.wzZJ0eOLe8RdJGfr2lyUSptMoJAUMRcFmuReKSJ7kj4',

    sync_data: null,
    sync_callback: null,
    close_callback: null,

    changed: false,
};

const {get, set, update, subscribe} = writable(passportsObject);

const passportsStore = {
    set,
    update,
    subscribe,

    setRequest: (data, syncCallBackFunction = null, closeCallBackFunction = null) => {
        passportsStore.update(obj => {
            obj.sync_data = data;
            obj.sync_callback = syncCallBackFunction;
            obj.close_callback = closeCallBackFunction;
            return obj;
        });
    },

    clearRequest: () => {
        passportsStore.update(obj => {
            obj.sync_data = null;
            obj.sync_callback = null;
            obj.close_callback = null;
            return obj;
        });
    },

    getPrefix: () => {
        return passportsObject.prefix;
    },

    // return an array with all passports from passport_from to passport_to
    // passportArray: () => {
    //     let arr = [];
    //     for (let i = parseInt(passportsObject.sync_data.passport_from); i <= parseInt(passportsObject.sync_data.passport_to); i++) {
    //         arr.push(passportsObject.prefix + setPassport(i));
    //     }
    //
    //     return arr;
    // },

    // create an array with passport chunks.
    // each chunk contains up to 25 passports
    // passportChunks: () => {
    //     let arr = passportsStore.passportArray();
    //
    //     let chunks = [];
    //     let chunk = [];
    //     arr.map(item => {
    //         chunk.push(item);
    //         if (chunk.length === 25) {
    //             chunks.push(chunk);
    //             chunk = [];
    //         }
    //     });
    //
    //     if (chunk.length) {
    //         chunks.push(chunk);
    //     }
    //
    //     return chunks;
    // }
}

export default passportsStore;